import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ShoppingBag, Heart, PlusSquare, Wrench, User } from "lucide-react";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: "/", icon: Home, label: "Home" },
    { path: "/shop", icon: ShoppingBag, label: "Shop" },
    { path: "/outlet", icon: Heart, label: "Outlet" },
    { path: "/prenotazione", icon: PlusSquare, label: "Prenota" },
    { path: "/assistenza", icon: Wrench, label: "Assistenza" },
    { path: "/profile", icon: User, label: "Profilo" },
  ];

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 h-16 bg-black/90 backdrop-blur-lg border-t border-white/10 flex justify-around items-center z-50"
      data-testid="bottom-navigation"
    >
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-center w-14 h-full transition-all duration-200 ${
              isActive ? "text-emerald-500" : "text-white/60 hover:text-white"
            }`}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <Icon 
              size={22} 
              strokeWidth={isActive ? 2 : 1.5}
              className={isActive ? "scale-110" : ""}
            />
            <span className="text-[9px] mt-1 uppercase tracking-wider">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNavigation;
